import React from "react";

const ProplusImpact = () => {
  return (
    <div className="subscribe_area">
     
       <div className="col-lg-12 case-study-details">
              
             
            <img
              src="assets/images/Siemens .webp" 
              alt="proplus data approach" 
              className="mx-auto w-32"
            /> 
         
         
        </div>
    </div>
  );
};

export default ProplusImpact;
